import { ConfirmDialog } from "components/ConfirmDialog";
import { Pagination } from "components/Tables/Pagination";
import { Table } from "components/Tables/Table";

import { Button } from "components/Button";
import { PageFilter } from "components/Page/PageFilter";
import { PageHeader } from "components/Page/PageHeader";
import { TableField } from "components/Tables/Table/components/TableBody";
import { Plan } from "models/plan";
import { Link } from "react-router-dom";
import { useViewModel } from "./viewModel";

export default function Plans() {
  const {
    navigate,
    plans,
    page,
    nbPages,
    confirmDialogData,
    handleChangeStatus,
    setPage,
    isLoading,
    isError,
    retry,
    user,
    t,
  } = useViewModel();

  const headers =
    user?.role === "admin"
      ? t("plans.table.admin_header", { returnObjects: true })
      : t("plans.table.provider_header", { returnObjects: true });

  const fields: TableField<Plan>[] =
    user?.role === "admin"
      ? [
          { key: "name" },
          { key: "description" },
          { key: "price" },
          { key: "providerName" },
          { key: "status", type: "status" },
        ]
      : [
          { key: "name" },
          { key: "description" },
          { key: "price" },
          { key: "status", type: "status" }
        ];

  return (
    <div>
      {confirmDialogData && <ConfirmDialog {...confirmDialogData} />}
      <div className="flex justify-between items-center">
        <PageHeader title={t("plans.title")} />
        <div className="flex items-center gap-3">
          <PageFilter hideTimeFilter />
          <Link to="/planos/novo">
            <Button leftIcon="/icons/form/add.svg">{t("actions.add")}</Button>
          </Link>
        </div>
      </div>
      <Table
        className="mt-7"
        headers={headers}
        fields={fields}
        data={plans}
        transforms={[
          {
            key: "price",
            transform: (plan) => `R$ ${plan.price.toFixed(2)}`,
          },
          {
            key: "status",
            transform: (plan) => plan.status === "active" ? t("plans.status.active") : t("plans.status.inactive"),
          },
        ]}
        isLoading={isLoading}
        hasError={isError}
        onRetry={retry}
        actions={(plan, index) => {
          return (
            <>
              <button onClick={() => navigate(`/planos/${plan.id}`)}>
                {t("actions.view")}
              </button>
              <button
                onClick={() => navigate(`/planos/editar/${plan.id}`)}
              >
                {t("actions.edit")}
              </button>
              {plan.status !== "active" && (
                <button
                  onClick={() => handleChangeStatus(index, "active")}
                >
                  {t("actions.activate")}
                </button>
              )}
              {plan.status !== "inactive" && (
                <button
                  onClick={() =>
                    handleChangeStatus(index, "inactive")
                  }
                >
                  {t("actions.inactivate")}
                </button>
              )}
            </>
          );
        }}
      />
      <Pagination
        currentPage={page}
        handleChangePage={setPage}
        numberOfPages={nbPages ?? 0}
      />
    </div>
  );
} 